import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SEO from '../components/SEO';
import Shortcuts from './shortcuts/Shortcuts';

const Home: React.FC = () => {
  return (
    <SEO title="Dashboard" description="">
      <Container>
        <Row>
          <Col>
          <h1 className="text-center">Shortcuts</h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <Shortcuts />
          </Col>
        </Row>
      </Container>
    </SEO>
  );
};

export default Home;
